module.exports = __webpack_public_path__ + "img/img18.6bd31569.svg";